import React from "react";
import { connect } from "react-redux";
import Nav from "react-bootstrap/Nav";

import { mainContentHeader } from "../../../../store/actions/dashboard";

const Header = props => {
  return (
    <div className="mt-2">
      <h2 className="mb-3">Agents/Callers</h2>
      <Nav
        className="mb-3"
        variant="pills"
        defaultActiveKey="agents_available_in"
        onSelect={selectedKey =>
          props.mainContentHeader({ active_tab: selectedKey })
        }
      >
        <Nav.Item>
          <Nav.Link className="rounded-pill" eventKey="agents_available_in">
            Agents - Available (IN)
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className="rounded-pill" eventKey="agents_available_out">
            Agents - Available (OUT)
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className="rounded-pill" eventKey="agents_aux">
            Agents - AUX
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className="rounded-pill" eventKey="callers">
            Callers
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className="rounded-pill" eventKey="q_stats">
            Queue Statistics
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    header: state.dashboardReducer.maincontent_header,
  };
};

export default connect(mapStateToProps, { mainContentHeader })(Header);
